import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { firestore } from '../firebase';
import { dateFormatter, dateFormatterFB } from '../helpers/dateFormatter';
import StateContext from '../StateContext';

function SinglePostPage() {

    const {id} = useParams();

    const appState = useContext(StateContext);

    const [post, setPost] = useState();

    useEffect(() => {

        try {
            const postRef = firestore.collection("football-blogs").doc(id);
            postRef.onSnapshot(doc => {
                const post = {id: doc.id, ...doc.data()}
                setPost(post);
            })
        } catch (error) {
            
        }

    }, [id])

    return (

        <div className="container">
            <h2 className="font-weight-bold mt-4">{post?.title}</h2>
            <p className="text-muted">
                <small>Av <span className="font-weight-bold">{post?.author_name}</span> den {dateFormatter(new Date(post?.date_iso))}</small>
                {appState.loggedIn && <span className="float-right"><Link to={`/innlegg/edit/${post?.id}`}><i className="fas fa-edit"></i></Link></span>}
            </p>
            <hr />

            <div dangerouslySetInnerHTML={{__html: post?.content}}></div>
        </div>

    )
}
export default SinglePostPage